import moment from "moment";
import { IFieldConfig } from "../../../components/form/types";

export const addPremiumDialogConfig: IFieldConfig = {
  insurerPartnerNumber: {
    name: "insurerPartnerNumber",
    type: "insurerVehicleTaxonomy",
    isRequired: true,
    d: ({ t }) => ({
      label: "bfm.insurer.label",
    }),
  },
  insurerBranchOffice: {
    name: "insurerBranchOffice",
    insurerFieldName: "insurerPartnerNumber",
    type: "insurerBranchOfficeTaxonomy",
    isRequired: false,
    d: ({ t }) => ({
      label: "bfm.vehicleForm.insurerBranchOffice.label",
    }),
  },
  insurerPolicyNumber: {
    name: "insurerPolicyNumber",
    type: "text",
    isRequired: true,
    d: ({ t }) => ({
      label: "bfm.vehicleForm.policyNumber.label",
    }),
  },
  insurerGroupPolicyNumber: {
    name: "insurerGroupPolicyNumber",
    type: "grouppolicynumber",
    isRequired: true,
    d: ({ t }) => ({
      label: "bfm.vehicleForm.groupPolicyNumber.label",
    }),
  },
  validFromDate: {
    name: "validFromDate",
    type: "date",
    isRequired: true,
    d: ({ t, values, errors, setFieldValue }) => ({
      label: "bfm.vehicleForm.validFromDate.label",
      values,
      errors,
      setFieldValue,
      defaultValue: values?.validFromDate,
    }),
  },
  annualGrossPremium: {
    name: "annualGrossPremium",
    type: "number",
    isRequired: true,
    d: ({ t, vehicle }) => ({
      label: "bfm.vehicleForm.annualGrossPremium.label",
      defaultValueFunction: (value) => value,
    }),
  },
  annualNetPremium: {
    name: "annualNetPremium",
    type: "number",
    isRequired: true,
    d: ({ t }) => ({
      label: "bfm.annualNetPremium.label",
      insurerSettingsFunction: (value) => value,
    }),
  },
  annualGrossPremiumEur: {
    name: "annualGrossPremiumEur",
    type: "number",
    isRequired: false,
    d: ({ t, vehicle }) => ({
      label: "bfm.vehicleForm.annualGrossPremiumEur.label",
      defaultValueFunction: (value) => value,
    }),
  },
  annualNetPremiumEur: {
    name: "annualNetPremiumEur",
    type: "number",
    isRequired: false,
    d: ({ t }) => ({
      label: "bfm.vehicleForm.annualNetPremiumEur.label",
      insurerSettingsFunction: (value) => value,
    }),
  },
  paymentMethod: {
    name: "paymentMethod",
    type: "taxonomy",
    taxonomyKey: "PaymentMethod",
    isRequired: true,
    d: ({ t }) => ({
      label: "bfm.vehicleForm.paymentMethod.label",
    }),
  },
  paymentMean: {
    name: "paymentMean",
    type: "taxonomy",
    taxonomyKey: "PremiumPaymentMean",
    isRequired: true,
    d: ({ t }) => ({
      label: "bfm.vehicleForm.paymentMean.label",
    }),
  },
  policyStatus: {
    name: "policyStatus",
    type: "taxonomy",
    taxonomyKey: "VehiclePolicyStatusCode",
    isRequired: true,
    d: ({ t }) => ({
      label: "bfm.vehicleForm.policyStatus.label",
    }),
  },

  policyStatusComment: {
    name: "policyStatusComment",
    type: "text",
    isMultiline: true,
    rows: 3,
    isRequired: false,
    d: ({ t, vehicle }) => ({
      label: "bfm.vehicleForm.policyStatusComment.label",
      defaultValueFunction: (value) => value,
    }),
  },
  suspensionDays: {
    name: "suspensionDays",
    type: "number",
    format: "integer",
    isRequired: true,
    d: ({ t, vehicle }) => ({
      label: "bfm.vehicleForm.horsePowerBasedTaxSuspensionDays.label",
      insurerSettingsFunction: (value) => value,
    }),
  },
  activationDays: {
    name: "activationDays",
    type: "number",
    format: "integer",
    isRequired: true,
    d: ({ t, vehicle }) => ({
      label: "bfm.vehicleForm.horsePowerBasedTaxActivationDays.label",
      insurerSettingsFunction: (value) => value,
    }),
  },
  suspensionDaysLimit: {
    name: "suspensionDaysLimit",
    type: "number",
    format: "integer",
    isRequired: true,
    isNegativeAllowed: true,
    d: ({ t, vehicle }) => ({
      label: "bfm.vehicleForm.horsePowerBasedTaxSuspensionDaysLimit.label",
      insurerSettingsFunction: (value) => value,
    }),
  },
  garageRiskDiscountPercent: {
    name: "garageRiskDiscountPercent",
    type: "number",
    isRequired: true,
    d: ({ t, vehicle }) => ({
      label: "bfm.vehicleForm.hullGarageRiskDiscountPercent.label",
      insurerSettingsFunction: (value) => value,
    }),
  },
  reasonForModificationComment: {
    name: "reasonForModificationComment",
    type: "text",
    isMultiline: true,
    rows: 3,
    isRequired: false,
    d: ({ t }) => ({
      label: "bfm.comment.label",
    }),
  },
  reasonForConcludingInsurance: {
    name: "reasonForConcludingInsurance",
    type: "textwithoptions",
    isMultiline: true,
    rows: 3,
    isRequired: false,
    d: ({ t }) => ({
      label: "bfm.reasonForConcludingInsurance.label",
    }),
    options: [
      "bfm.reasonForConcludingInsurance.options.inheritanceLegallyBinding",
      "bfm.reasonForConcludingInsurance.options.contractTerminationAnniversary",
      "bfm.reasonForConcludingInsurance.options.newVehicleHungary",
      "bfm.reasonForConcludingInsurance.options.usedVehicleHungary",
      "bfm.reasonForConcludingInsurance.options.importedVehicleFirstRegistration",
      "bfm.reasonForConcludingInsurance.options.operatorChange",
      "bfm.reasonForConcludingInsurance.options.contractRenewalAfterNonPayment",
      "bfm.reasonForConcludingInsurance.options.vehicleReinstatementToTraffic",
      "bfm.reasonForConcludingInsurance.options.contractRenewalMutualAgreement",
      "bfm.reasonForConcludingInsurance.options.insuranceTransfer",
      "bfm.reasonForConcludingInsurance.options.other",
    ],
  },
  reasonForCancellingInsurance: {
    name: "reasonForCancellingInsurance",
    type: "textwithoptions",
    isMultiline: true,
    rows: 3,
    isRequired: false,
    d: ({ t }) => ({
      label: "bfm.reasonForCancellingInsurance.label",
    }),
    options: [
      "bfm.reasonForCancellingInsurance.options.noHistory",
      "bfm.reasonForCancellingInsurance.options.nonPayment",
      "bfm.reasonForCancellingInsurance.options.saleExpiration",
      "bfm.reasonForCancellingInsurance.options.loseInterest",
      "bfm.reasonForCancellingInsurance.options.insuranceCancellationAnniversaryInsurer",
      "bfm.reasonForCancellingInsurance.options.insuranceCancellationAnniversaryClient",
      "bfm.reasonForCancellingInsurance.options.finalWithdrawalFromCirculation",
      "bfm.reasonForCancellingInsurance.options.economicTotalLoss",
      "bfm.reasonForCancellingInsurance.options.technicalTotalLoss",
      "bfm.reasonForCancellingInsurance.options.terminationDueToOperatorChange",
      "bfm.reasonForCancellingInsurance.options.loseInterestDueToOperatorChange",
      "bfm.reasonForCancellingInsurance.options.terminationByMutualAgreement",
      "bfm.reasonForCancellingInsurance.options.insurerTerminationDueToRisk",
    ],
  },
  hullIsBasic: {
    name: "hullIsBasic",
    type: "hulltypecombobox",
    isRequired: true,
    d: ({ t }) => {
      return {
        label: "bfm.vehicleForm.hullType.label",
        options: [
          { value: "false", label: t("bfm.vehicleForm.hullType.full.label") },
          {
            value: "true",
            label: t("bfm.vehicleForm.hullType.basic.label"),
          },
        ],
      };
    },
  },
  isMotorTaxIncluded: {
    name: "isMotorTaxIncluded",
    type: "checkbox",
    d: ({ t }) => ({
      label: "bfm.isMotorTaxIncluded.label",
    }),
  },
  motorTaxExclusionReason: {
    name: "motorTaxExclusionReason",
    type: "taxonomy",
    taxonomyKey: "ReasonForMotorTaxExclusion",
    isRequired: true,
    d: ({ t, values }) => ({
      label: "bfm.reasonForMotorTaxExclusion.label",
      isDisabled: values.isMotorTaxIncluded,
      isVisible: !values.isMotorTaxIncluded,
    }),
  },
  motorTaxPaymentMethod: {
    name: "motorTaxPaymentMethod",
    type: "taxonomy",
    taxonomyKey: "PaymentMethod",
    isRequired: true,
    d: ({ t, values }) => ({
      label: "bfm.vehicleForm.paymentMethod.label",
      isDisabled: !values.isMotorTaxIncluded,
      isVisible: values.isMotorTaxIncluded,
    }),
  },
  motorTaxPaymentMean: {
    name: "motorTaxPaymentMean",
    type: "taxonomy",
    taxonomyKey: "PremiumPaymentMean",
    isRequired: true,
    d: ({ t, values }) => ({
      label: "bfm.vehicleForm.paymentMean.label",
      isDisabled: !values.isMotorTaxIncluded,
      isVisible: values.isMotorTaxIncluded,
    }),
  },
  motorTaxSuspensionDaysLimit: {
    name: "motorTaxSuspensionDaysLimit",
    type: "number",
    isRequired: true,
    isNegativeAllowed: true,
    d: ({ t, values, vehicle }) => ({
      label: "bfm.vehicleForm.horsePowerBasedTaxSuspensionDaysLimit.label",
      isDisabled: !values.isMotorTaxIncluded,
      isVisible: values.isMotorTaxIncluded,
      insurerSettingsFunction: (value) => value,
    }),
  },
  motorTaxExclusionComment: {
    name: "motorTaxExclusionComment",
    type: "text",
    isMultiline: true,
    rows: 7,
    isRequired: false,
    d: ({ t, values }) => ({
      label: "bfm.comment.label",
    }),
  },
  validToDate: {
    name: "validToDate",
    type: "date",
    isRequired: true,
    d: ({ t, values, errors, setFieldValue }) => ({
      label: "bfm.vehicleForm.validToDate.label",
      values,
      errors,
      setFieldValue,
      defaultValue: values?.validToDate,
    }),
  },
  validToDateNotRequired: {
    name: "validToDate",
    type: "date",
    isRequired: false,
    d: ({ t, values, errors, setFieldValue }) => ({
      label: "bfm.vehicleForm.validToDate.label",
      values,
      errors,
      setFieldValue,
      defaultValue: values?.validToDate,
    }),
  },
  expiryDate: {
    name: "expiryDate",
    type: "date",
    isRequired: true,
    d: ({ t, values, errors, setFieldValue }) => ({
      label: "bfm.vehicleForm.expiryDate.label",
      values,
      errors,
      setFieldValue,
      defaultValue: values?.expiryDate,
    }),
  },
  greenCardExpiryDate: {
    name: "greenCardExpiryDate",
    type: "date",
    isRequired: false,
    d: ({ t, values, errors, setFieldValue }) => ({
      label: "bfm.vehicleForm.greenCardExpiryDate.label",
      values,
      errors,
      setFieldValue,
      defaultValue: values?.greenCardExpiryDate,
    }),
  },
  isPolicyIssued: {
    name: "isPolicyIssued",
    type: "checkbox",
    isRequired: true,
    d: ({ t }) => ({
      label: "bfm.vehicleForm.isPolicyIssued.label",
    }),
  },
  hullProduct: {
    name: "hullProduct",
    type: "hullproduct",
    isRequired: true,
    d: ({ t }) => ({
      label: "bfm.vehicleForm.hullProduct.label",
    }),
  },
  hullDeductible: {
    name: "hullDeductible",
    type: "number",
    isRequired: false,
    d: ({ t, vehicle }) => ({
      label: "bfm.vehicleForm.hullDeductible.label",
      defaultValueFunction: (value) => value,
    }),
  },
  hullDeductiblePercent: {
    name: "hullDeductiblePercent",
    type: "number",
    format: "integer",
    isRequired: true,
    d: ({ t, vehicle }) => ({
      label: "bfm.vehicleForm.hullDeductiblePercent.label",
      defaultValueFunction: (value) => value,
    }),
  },
  hullDeductibleMaxAmount: {
    name: "hullDeductibleMaxAmount",
    type: "number",
    isRequired: false,
    d: ({ t, vehicle }) => ({
      label: "bfm.vehicleForm.hullDeductibleMaxAmount.label",
      defaultValueFunction: (value) => value,
    }),
  },
  hullDeductibleMinAmount: {
    name: "hullDeductibleMinAmount",
    type: "number",
    isRequired: true,
    d: ({ t, vehicle }) => ({
      label: "bfm.vehicleForm.hullDeductibleMinAmount.label",
      defaultValueFunction: (value) => value,
    }),
  },

  hullDeductibleComment: {
    name: "hullDeductibleComment",
    type: "text",
    isMultiline: true,
    rows: 3,
    isRequired: true,
    d: ({ t, vehicle }) => ({
      label: "bfm.vehicleForm.hullDeductibleComment.label",
      defaultValueFunction: (value) => value,
    }),
  },
  hullAdditionalCover: {
    name: "hullAdditionalCover",
    type: "text",
    isMultiline: true,
    rows: 3,
    isRequired: false,
    d: ({ t, vehicle }) => ({
      label: "bfm.vehicleForm.hullAdditionalCover.label",
      defaultValueFunction: (value) => value,
    }),
  },
  gap: {
    name: "gap",
    type: "radiogroup",
    isRequired: true,
    d: ({ t }) => ({
      label: "bfm.vehicleForm.gap.label",
    }),
  },
  replacementValue: {
    name: "replacementValue",
    type: "radiogroup",
    isRequired: true,
    d: ({ t }) => ({
      label: "bfm.vehicleForm.replacementValue.label",
    }),
  },
  grossNegligence: {
    name: "grossNegligence",
    type: "radiogroup",
    isRequired: true,
    d: ({ t }) => ({
      label: "bfm.vehicleForm.grossNegligence.label",
    }),
  },

  electroPlusPackage: {
    name: "electroPlusPackage",
    type: "radiogroup",
    isRequired: true,
    d: ({ t }) => ({
      label: "bfm.vehicleForm.electroPlusPackage.label",
    }),
  },
  dueDate: {
    name: "dueDate",
    type: "dueDate",
    dayFieldName: "dueDay",
    monthFieldName: "dueMonth",
    isRequired: true,
    d: ({ t }) => ({
      label: "bfm.fleetForm.dueDate.label",
    }),
  },
  documentDate: {
    name: "documentDate",
    type: "date",
    isRequired: false,
    d: ({ t, values, errors, setFieldValue }) => ({
      label: "bfm.vehicleForm.documentDate.label",
      values,
      errors,
      setFieldValue,
      defaultValue: values?.documentDate || moment(new Date()).toDate(),
    }),
  },
  cancelationDocumentDate: {
    name: "cancelationDocumentDate",
    type: "date",
    isRequired: false,
    d: ({ t, values, errors, setFieldValue }) => ({
      label: "bfm.vehicleForm.cancelationDocumentDate.label",
      values,
      errors,
      setFieldValue,
      defaultValue: values?.cancelationDocumentDate,
    }),
  },
};
